import extendedMenuDesktop from '../../../../components/extended-menu/extended-menu.desktop';
import extendedMenu from './extended-menu';

const ExtendedMenuDesktop = extendedMenu(extendedMenuDesktop);
export default ExtendedMenuDesktop;
